import React, { useMemo } from 'react'
import { Body, Button, LinkInline, Subtitle } from '@dasa-health/alma-react'
import { useAppContext } from '@nsw-paginas-deslogadas/store/useAppContext'
import { Images, BrandMapping } from '@nsw-paginas-deslogadas/assets'
import * as S from './styles'

const FoldAboutNav: React.FC = () => {
    const { CellPhoneIllustration } = Images
    const { brand: brand_, product } = useAppContext()
    const brand = BrandMapping[brand_.mappingId]

    const productLabel = useMemo(() => `Agendar ${product.category?.id === 4 ? 'vacina' : 'exame'}`, [product])

    const slashLength = window.location.pathname.match(/\//g)?.length

    const dataAtributtes = (dataText: string) => ({
        'data-item-position': 'O que é Nav?',
        'data-current-service': slashLength && slashLength > 2 ? 'Página de Produto da Marca' : 'Página da Marca',
        'data-item-text': dataText,
    })

    return (
        <S.Container data-testid="about-testID">
            <S.Img alt={CellPhoneIllustration.alt} src={CellPhoneIllustration.src} />
            <S.Content>
                <S.BoxText>
                    <Subtitle size={'md'}>O que é o Nav Dasa?</Subtitle>
                    <Body>
                        Eu sou o Nav Dasa, plataforma de saúde digital da Dasa e sua também, pra você cuidar da saúde por inteiro.
                        Depois de se cadastrar na minha plataforma, você pode passar pelo pronto atendimento online, agendar consultas,
                        marcar exames, acompanhar seu histórico de saúde, em um só lugar, e muito mais.
                    </Body>
                </S.BoxText>

                <S.ButtonsBox>
                    {product?.category && (
                        <LinkInline
                            href={product.navigateTo}
                            sx={{ textDecoration: 'none' }}
                            target="_self"
                            {...dataAtributtes(productLabel)}
                        >
                            <Button data-testid="btn-vaccines">{productLabel}</Button>
                        </LinkInline>
                    )}

                    {!product?.category && (
                        <>
                            {brand.vaccine && (
                                <LinkInline
                                    href={brand.buttons.about.vaccines}
                                    sx={{ textDecoration: 'none' }}
                                    target="_self"
                                    {...dataAtributtes('Agendar vacinas')}
                                >
                                    <Button data-testid="btn-vaccines">Agendar vacina</Button>
                                </LinkInline>
                            )}
                            <LinkInline
                                href={brand.buttons.about.exams}
                                sx={{ textDecoration: 'none' }}
                                target="_self"
                                {...dataAtributtes('Agendar exames')}
                            >
                                <Button data-testid="btn-exams">Agendar exame</Button>
                            </LinkInline>
                        </>
                    )}
                </S.ButtonsBox>
            </S.Content>
        </S.Container>
    )
}
export default FoldAboutNav
